<template>
  <b-navbar
    toggleable="lg"
    type="dark"
    variant="dark"
    class="mb-3"
  >
    <b-container fluid>
      <b-navbar-brand
        to="/"
        class="text-wrap"
      >
        Бгатокритеріальний вибір альтернатив на основі динамічних критеріїв ефективності
      </b-navbar-brand>
    </b-container>
  </b-navbar>
</template>

<script>
export default {}
</script>
